import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { InjectionSite } from '../../fulfillmentContext/types';

export interface InjectionSitesModel {
  injectionSitesMap: Record<string, InjectionSite>;
  setInjectionSites: Action<InjectionSitesModel, InjectionSite[]>;
  setInjectionSite: Action<InjectionSitesModel, InjectionSite>;
  fetchInjectionSitesLoading: boolean;
  setFetchInjectionSitesLoading: Action<InjectionSitesModel, boolean>;
  fetchInjectionSites: Thunk<InjectionSitesModel, void, Injections, StoreModel, Promise<void>>;
  fetchInjectionSitesFailure: Action<InjectionSitesModel, ApplicationErrorOptions>;
}

export const injectionSitesModel: InjectionSitesModel = {
  injectionSitesMap: {},
  setInjectionSites: action((state, injectionSites) => {
    const injectionSitesMap = injectionSites.reduce<Record<string, InjectionSite>>((acc, curr) => {
      acc[curr.injectionSiteId] = curr;
      return acc;
    }, {});
    state.injectionSitesMap = injectionSitesMap;
  }),
  setInjectionSite: action((state, injectionSite) => {
    state.injectionSitesMap[injectionSite.injectionSiteId] = injectionSite;
  }),
  fetchInjectionSitesLoading: false,
  setFetchInjectionSitesLoading: action((state, isLoading) => {
    state.fetchInjectionSitesLoading = isLoading;
  }),
  fetchInjectionSites: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchInjectionSitesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchInjectionSites();
      actions.setInjectionSites(response);
      actions.setFetchInjectionSitesLoading(false);
      return response;
    } catch (error) {
      actions.fetchInjectionSitesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchInjectionSitesLoading(false);
      return error;
    }
  }),
  fetchInjectionSitesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default injectionSitesModel;
